module.exports = __webpack_public_path__ + "static/media/wallet.19c28130.svg";